module.exports = __webpack_public_path__ + "static/media/whatsapp.bb02442f.svg";